import { withCurrentParams } from 'actions/utils';
import { BROADCAST_UPDATE_SOURCE } from 'actions/Types';
import setSingleSourceProgram from './setSingleSourceProgram';
import { getSignedUrl } from 'utils/broadcastSourceHelper';

export default source => {
  return withCurrentParams((dispatch, { teamId, eventId, broadcastId }) => {
    const changes = {
      hidden: !source.hidden
    };

    const action = {
      type: BROADCAST_UPDATE_SOURCE,
      request: async apiClient => {
        const response = await apiClient.broadcast.updateSource(
          teamId,
          eventId,
          broadcastId,
          source._id,
          changes
        );

        const updatedSource = await getSignedUrl(
          {
            ...response,
            team: teamId,
            event: eventId
          },
          apiClient
        );

        dispatch(setSingleSourceProgram(updatedSource));
        return updatedSource;
      }
    };

    if (!source.hidden) {
      dispatch(setSingleSourceProgram(source));
    } else {
      dispatch(action);
    }
  });
};
